 
 
  
 
// const BaseApi = "https://qms-toyotaparagon.com" 

  const BaseApi = "https://www.quickmanagesoft.com"

// const BaseApi = "http://43.254.133.128/sureprg" 

// const BaseApi = "http://43.254.133.244" 

// const BaseApi = "http://43.254.133.128" 

// const BaseApi = "http://127.0.0.1:5000" 
 
export default BaseApi;

 